module.exports = __webpack_public_path__ + "img/code-vue-xs.5551b82d.webp";